import styled, { css } from 'styled-components'
import { Link, NavLink } from 'react-router-dom'
import { theme, media, minMedia } from '../../styles/_variables'

export const MenuWrapper = styled.div`
  display: inline-flex;
  background-color: ${theme.color.offWhite};
  box-shadow: 0 4px 7px rgba(0, 0, 0, 0.46);
  position: relative;
  z-index: ${theme.zIndex.menuList};
  ${minMedia.laptopXL`
    width: 59vw;
    display: inline-flex;
    justify-content: space-between;
  `}
  ${media.laptop`
    display: flex;
    justify-content: space-between;
    box-shadow: none;
  `}
  > div {
    &:first-child {
      margin: 0 56px 0 0;
      @media only screen and (min-width: 961px) and (max-width: 1024px) {
        margin: 0 8px 0 0;
      }
      ${minMedia.laptop`
        margin: 0 28.37px 0 0;
      `}
    }
  }
`

export const LogoWrapper = styled.img`
  padding: 0 16px;
  height: 40px;
`

export const MenuListWrapper = styled.div`
  display: flex;
  position: relative;
  z-index: ${theme.zIndex.menuList};
  background-color: ${theme.color.offWhite};
`

export const LinkBox = styled(NavLink)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: ${theme.fonts.size.extraNormal};
  color: ${props => (props.color ? props.color : theme.color.textColor)};
  padding: 16px;
  ${media.laptop`
    padding: 16px;
     min-width: 110px;
  `}
  ${minMedia.laptopL`
    padding: 16px;
    min-width: 110px;
  `}
  ${minMedia.laptopXL`
    padding: 16px;
    min-width: 110px;
  `}
  min-width: 110px;
  transition: all 0.4s ease;
  line-height: 1;
  font-weight: 600;
  &:focus,
  &:active,
  &:hover {
    text-decoration: none;
    color: #808181;
  }
  &:not(.active):hover {
    color: ${theme.color.primaryColor};
  }
  &:not(.active):active {
    color: ${theme.color.offWhite};
    background-color: ${theme.color.tertiaryColor};
  }
  > span {
    display: block;
  }
  &.active {
    background-color: ${theme.color.primaryColor};
    color: ${theme.color.offWhite};
    > i {
      color: ${theme.color.offWhite};
    }
    &:hover {
      background-color: rgba(${theme.color.primaryColorRGB}, 0.8);
    }
  }
`

export const LinkBoxContainer = styled(NavLink)`
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: ${theme.fonts.size.extraNormal};
  color: ${props => (props.color ? props.color : theme.color.textColor)};
  padding: 16px;
  ${media.laptop`
    padding: 16px 0px 16px 0px;
    min-width: 110px;
  `}
  ${minMedia.laptopL`
    padding: 16px;
    min-width: 110px;
  `}
  ${minMedia.laptopXL`
    padding: 16px;
    min-width: 110px;
  `}
  ${media.laptop`
    padding: 16px;
    min-width: 110px;
  `}
  min-width: 110px;
  transition: all 0.4s ease;
  line-height: 1;
  &:focus,
  &:active,
  &:hover {
    text-decoration: none;
    color: #808181;
  }
  > i {
    transition: all 0.4s ease;
  }
  &:not(.active):hover {
    > i {
      color: ${theme.color.primaryColor};
    }
  }
  &:not(.active):active {
    background-color: ${theme.color.tertiaryColor};
    > i {
      color: ${theme.color.offWhite};
    }
  }
  > span {
    display: block;
  }
  &.active {
    background-color: ${theme.color.primaryColor};
    color: ${theme.color.offWhite};
    > i {
      color: ${theme.color.offWhite};
    }
    &:hover {
      background-color: rgba(${theme.color.primaryColorRGB}, 0.8);
    }
  }
`

export const LinkDiv = styled.div`
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: ${theme.fonts.size.extraNormal};
  color: ${props => (props.color ? props.color : theme.color.textColor)};
  padding: 16px;
  min-width: 110px;
  ${media.laptop`
    padding: 16px 0px 16px 0px;
    min-width: 110px;
  `}
  ${minMedia.laptopL`
    padding: 16px 0px 16px 0px;
    min-width: 110px;
  `}
  ${minMedia.laptopXL`
    padding: 16px;
    min-width: 110px;
  `}
  ${media.laptop`
    padding: 16px 0px 16px 0px;
    min-width: 110px;
  `}
  transition: all 0.4s ease;
  line-height: 1;
  font-weight: 600;
  &:focus,
  &:active,
  &:hover {
    text-decoration: none;
    color: #808181;
  }
  > i {
    transition: all 0.4s ease;
  }
  &:not(.active):hover {
    color: ${theme.color.primaryColor};
    > i {
      color: ${theme.color.primaryColor};
    }
  }
  &:not(.active):active {
    background-color: ${theme.color.tertiaryColor};
    color: ${theme.color.offWhite};
    > i {
      color: ${theme.color.offWhite};
    }
  }
  > span {
    display: block;
  }
  &.active {
    background-color: ${theme.color.primaryColor};
    color: ${theme.color.offWhite};
    > i {
      color: ${theme.color.offWhite};
    }
    &:hover {
      background-color: rgba(${theme.color.primaryColorRGB}, 0.8);
    }
  }
`

export const MenuMobile = styled.div`
  > .fa-bars {
    padding: 24px 16px;
  }
  > ${MenuListWrapper} {
    max-height: 0;
    overflow: hidden;
    box-shadow: 0 4px 7px rgba(0, 0, 0, 0.46);
    transition: max-height 0.8s ease;
    position: absolute;
    right: 0;
    left: 0;
    flex-direction: column;
    ${LinkBox} {
      flex-direction: row;
      span {
        margin-left: 8px;
      }
    }
    ${props => (props.active && css`
      max-height: 400px;
    `)}
  }
`

export const FooterTitle = styled.div`
  &:first-child {
    margin-right: 160px;
    ${media.tablet`
      margin: 56px 0 0;
    `}
  }
  > h3 {
    position: relative;
    ${media.tablet`
      font-size: ${theme.fonts.size.subTitle};
      margin-left: 10px;
    `}
    &::before {
      content: '';
      position: absolute;
      top: -10px;
      bottom: 10px;
      left: -10px;
      width: 5px;
      background-color: ${theme.color.primaryColor};
      ${media.tablet`
        bottom: 8px;
      `}
    }
  }
  > div {
    &.menu-list {
      ${media.tablet`
        margin-left: 0;
        > div {
          &:last-child {
            margin-left: 48px;
          }
        }
      `}
      ${media.mobileM`
        > div {
          &:last-child {
            margin-left: 16px;
          }
        }
      `}
    }
    > div {
      ${media.tablet`
        flex-direction: column;
        > div {
          margin: 0;
          > p {
            margin-top: 0;
          }
        }
      `}
    }
  }
`

export const QrcodeImage = styled.img`
  max-height: 120px;
  border: 4px solid ${theme.color.primaryColor};
  border-radius: 4px;
`

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${theme.color.lightBlack};
  color: ${theme.color.offWhite};
  padding: 48px 0;
  ${media.tablet`
    padding: 40px 16px;
    flex-direction: column;
    > ${FooterTitle} {
      &:first-child {
        order: 2
      }
      &:last-child {
        order: 1
      }
    }
  `}
`

export const ContainerWrapper = styled.div`
  ${props => props.blur && css`
    filter: blur(20px);
  `}
  ${props => props.isHome && css`
    ${media.tablet`
      padding-top: 66px;
    `}
  `}
  ${props => !props.isHome && css`
    background-color: #f6f5f5;
  `}
  ${props => props.backgroundColor && css`
    background-color: ${props.backgroundColor};
  `}
`

export const HeaderWrapper = styled.div`
  position: relative;
  background-image: ${props => props.bgImg && `url(${props.bgImg})`};
  background-size: cover;
  background-position: top center;
  padding: 64px 0 32px;
  text-align: center;
  ${media.laptop`
    padding: 0;
    background-position: bottom center;
  `}
  > * {
    position: relative;
    z-index: 2;
    ${media.laptop`
      display: block;
      > h1 {
        margin: 101px 16px 0px;
        font-size: ${theme.fonts.size.title};
        font-weight: normal;
        padding-bottom: 16px;
      }
    `}
  }
`

export const WidthContainer = styled.div`
  width: 100%;
  max-width: ${theme.maxWidth};
  margin-left: 50%;
  transform: translateX(-50%);
  padding: 0 16px;
  padding: ${props => (props.padding ? props.padding : '0 16px')};
  ${props => props.bgColor && css`
    background-color: ${props.bgColor};
  `}
  ${minMedia.laptopXL`
    max-width: 59vw;
  `}
  ${media.tablet`
    width: 100%;
    max-width: 100%;
  `}
`

export const FooterIcon = styled.img`
  width: 20px;
  margin: 0 16px 0 0;
`

export const FooterLink = styled(Link)`
  display: block;
  &:hover {
    > p {
      text-decoration: underline;
    }
  }
`

export default MenuWrapper



// WEBPACK FOOTER //
// ./src/components/container/styled.js